export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-3.e7ac6568.jpg";